module.exports = __webpack_public_path__ + "img/web_morse_4.9a1aff19.jpg";